export default __webpack_public_path__ + "static/media/ido.458ef8ef.png";